import type { Background } from '@/api/types/background'

/**
 * Matches legacy's `searchResultsforClikArtandBackground` (odctrl.js ~line 13380): every selected
 * keyword must be present on the item (AND, not OR) — legacy compares keyword NAMEs off each
 * item's own rendered `data-value` list; we compare by id instead (more robust — names aren't
 * guaranteed unique/stable), using each background's own `cmsKeywordInfo`.
 */
export function filterBackgroundsByKeywords(
  backgrounds: Background[],
  selectedKeywordIds: readonly string[]
): Background[] {
  if (selectedKeywordIds.length === 0) return backgrounds

  return backgrounds.filter((background) => {
    const backgroundKeywordIds = new Set(
      (background.cmsKeywordInfo ?? []).map((keyword) => String(keyword.cmsKeywordId))
    )

    return selectedKeywordIds.every((id) => backgroundKeywordIds.has(id))
  })
}
